import { IIsiDtoPlExportInfo, IIsiDtoPlMergeModelMergeMailPjResult, IIsiDtoPlMergeModelMergeResult, IIsiDtoPlMergeModelRequest, IsiDtoPlMergeModelRequest } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlMergeModel";
import { ExportType, IIsiDtoGLOBXXXOpenArgs, IIsiUIFlowResult, IsiDtoGlobMergeOpenArgs, ScreenType } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPopins";
import { GLOB017, GLOB026 } from "../../Isilog.popins";
import { Firefox, IOs } from "../../IsiWebGUI/core.ts";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";
import { IsiUiFlowUtils } from "../Core/IsiUIFlowUtils";
import { IsiIWSAssociatedViewContext } from "../GridView/AssociatedView/IsiIwsAssociatedViewContext";
import { IsiPlAssociatedViewManager } from "./IsiPlAssociatedViewManager";
import { IsiPresentationLogic } from "./IsiPresentationLogic";

/**
 * PL regroupant les méthodes de génération d'une fusion
 */
export class IsiPlMergeModel extends IsiPresentationLogic {

    // =============================
    // Constructor
    // =============================

    constructor() {

        super("IsiPlMergeModelHandler");
    }

    /**
     * Lance l'affichage du publipostage
     */
    public async launchGridMerge(assId: string,actioncontextId:string): Promise<IIsiUIFlowResult> {
        const plAssociatedViewManager = new IsiPlAssociatedViewManager();
        await plAssociatedViewManager.uploadClientState(clientState.associatedViewManager.states[assId]);
        const dto: IIsiDtoGLOBXXXOpenArgs = await uiCore.openGlob('IsiDtoGLOBXXXOpenArgs',
            {
                "associatedviewContextId": assId,
                "actionContextId": actioncontextId,
            });
        GLOB026().open(dto, {
            width: 450,
            height: uiCore.isTouchMode()?630:450,
            resizeToFitContent: true,
            widthToHeightRatio: 0.94
        });

        return IsiUiFlowUtils.stopExecution;
    }

    /**
     * Lance l'affichage de l'export
     */
    public async launchGridExport(associatedViewContext: IsiIWSAssociatedViewContext): Promise<IIsiUIFlowResult> {
        const plAssociatedViewManager = new IsiPlAssociatedViewManager();
        const associatedviewContextId = associatedViewContext.id;
        const screenName = associatedViewContext.name;
        const exportInfo = await this.getInfoExport(screenName);
        await plAssociatedViewManager.uploadClientState(clientState.associatedViewManager.states[associatedviewContextId]);
        GLOB017().open(IsiDtoGlobMergeOpenArgs.fromJS({
            associatedviewContextId: associatedviewContextId,
            screenName: screenName,
            exportType: ExportType.TEXCEL,
            screenType: exportInfo?.reponse?.screenType,
            screenHierName: exportInfo?.reponse?.screenHierName
        }));
        return IsiUiFlowUtils.stopExecution;
    }

    // =============================
    // Public methods
    // =============================

    /**
     * Lance la fusion d'un modèle
     * 
     * @param dto Paramètres à envoyer au serveur. Doivent être renseignés :
     * eltEnCours, assoPJ, presentMerge, prefixeSequence, suffixeSequence, dataRestricted,
     * screenType, screenDesignName, associatedViewContextId, codeModel, modelType,
     * useSequence, startSequence, endSequence
     * 
     * @returns Le href de chacun des fichiers générés. Liste vide si aucun.
     */
    public merge(dto: IIsiDtoPlMergeModelRequest): Promise<void> {
        return new Promise(async (resolve, reject) => {
            if (dto == null) {

                const errorMessage: string = getMessagesForJavascript()?.GetMessage("ParametreNull")?.L_MESSAGE?.replace('§s', 'dto');
                reject(errorMessage);
            } else {

                dto.response = {}

                const flowResult: IIsiUIFlowResultGeneric<IIsiDtoPlMergeModelRequest> = await this.ajaxWithErrorHandling("Merge", IsiDtoPlMergeModelRequest.fromJS(dto), true);

                const flowResults: IIsiUIFlowResultGeneric<IIsiDtoPlMergeModelMergeResult> = await IsiUiFlowUtils.createFlowWithResponse(flowResult, flowResult?.reponse?.response?.mergeResult)
                const files: string[] = flowResults?.reponse?.files;
                const errorMsg: string = flowResults?.reponse?.errorMsg;
                const sleep = (ms) => new Promise(r => setTimeout(r, ms));

                if (flowResults?.continue === true) {

                    if (errorMsg) {
                        reject(errorMsg);
                    }

                    if (files != null) {


                        for (const href of files) {
                            if (IOs || Firefox) {

                                window.open(href, '_blank');

                            } else {
                                window.location.assign(href);
                                //Sleep ajouté car ce bout de code est du copier coller d'un bout de code dans la glob026 pour le mode merge.
                                //C'est dû j'imagine à une raison historique.
                            }
                            await sleep(500);
                        }
                    }
                }
                resolve();
            }
        })
    }

    /**
     * Lance la fusion d'un modèle, dans le cas d'une PJ de mail en attente du fusion
     */
    public async mergeMailPj(dto: IIsiDtoPlMergeModelRequest): Promise<IIsiUIFlowResultGeneric<IIsiDtoPlMergeModelMergeMailPjResult>> {

        if (dto == null) {

            const errorMessage: string = getMessagesForJavascript()?.GetMessage("ParametreNull")?.L_MESSAGE?.replace('§s', 'dto');
            throw new Error(errorMessage);
        }

        dto.response = {}

        const flowResult: IIsiUIFlowResultGeneric<IIsiDtoPlMergeModelRequest> = await this.ajaxWithErrorHandling("MergeMailPj", IsiDtoPlMergeModelRequest.fromJS(dto), true);

        return IsiUiFlowUtils.createFlowWithResponse(flowResult, flowResult?.reponse?.response?.mergeMailPjResult);
    }

    /**
     * Récupère les infos sur l'écran hiérarchique et le type d'écran pour l'export excel 
     */
    public async getInfoExport(screenName: string): Promise<IIsiUIFlowResultGeneric<IIsiDtoPlExportInfo>> {

        const dto: IIsiDtoPlMergeModelRequest = {
            screenName: screenName, response: {}
}

        const flowResult: IIsiUIFlowResultGeneric<IIsiDtoPlMergeModelRequest> = await this.ajaxWithErrorHandling("Export", IsiDtoPlMergeModelRequest.fromJS(dto), true);

        return IsiUiFlowUtils.createFlowWithResponse(flowResult, flowResult?.reponse?.response?.exportInfos);
    }
}